import React, { Component, Fragment } from "react";
import { Button, Col, Icon, Result, Row, Tabs, Select } from "antd";
import * as Func from "../../../../helpers/functions";
import DEFINE, { FEATURE_FLAGS } from "../../../../constants/Define";
import { groupBy } from "lodash";
import * as HMS from "../../common/component/Index";
import Ripple from "containers/backend/common/component/Ripple";

export default class ClearCache extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: {},
      keyProductType: [],
      listKeyFollowType: {},
      listKeyAfterFilter: [],
      keysDelete: [],
    };
  }

  componentDidMount() {
    this.setState({
      permissions: Func.getPermissionActions(
        DEFINE.GENERAL.ROUTE_NAME.CLEAR_CACHE
      ),
    });
    this.props.getListCache();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.cacheRedisState !== this.props.cacheRedisState) {
      const {
        data: { listRedisKey: allKeys },
      } = this.props.cacheRedisState;
      const listType = groupBy(allKeys, "productType");
      this.setState({
        keyProductType: Object.keys(listType),
        listKeyFollowType: listType,
        listKeyAfterFilter: allKeys.filter(
          (item) => item.productType === Object.keys(listType)[0]
        ),
      });
    }
  }

  render() {
    const { t, cacheRedisState } = this.props;
    const { isFetching, data } = cacheRedisState;
    const { permissions, listKeyAfterFilter, keyProductType, keysDelete } = this.state;
    return (
      <Fragment>
        <HMS.PageListComponent
          onChangeLanguage={
            FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage
          }
        >
          <HMS.HeaderListComponent
            path={this.props.match.path}
            groupPath={"websites"}
            titleHeader={t("navigation.clearCache")}
          />
          {permissions && permissions.allowView ? (
            <>
              <Row gutter={16}>
                <Col span={12}>
                  <Tabs
                    className="tabs-sitetype"
                    defaultActiveKey={keyProductType?.[0]}
                    onChange={this.onChangeTab}
                    tabBarExtraContent={
                      permissions &&
                      permissions.allowClearCacheRedis && (
                        <Ripple
                          color="rgba(255, 255, 255, 0.8)"
                          waitForEffect={true}
                        >
                          <Button
                            type="primary"
                            onClick={this.onClearCache}
                            disabled={isFetching || ( keysDelete || []).length === 0}
                          >
                            {t("action.clearCache")}
                          </Button>
                        </Ripple>
                      )
                    }
                  >
                    {keyProductType.map((item, index) => {
                      return (
                        <Tabs.TabPane tab={<span>{item}</span>} key={item} />
                      );
                    })}
                  </Tabs>
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  <Select
                    key={listKeyAfterFilter?.length}
                    style={{ width: "100%" }}
                    onChange={this.onSelectKey}
                    allowClear
                  >
                    {(listKeyAfterFilter || []).map((item, index) => {
                      return (
                        <Select.Option key={item?.id} value={item.id}>
                          {item?.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Col>
              </Row>
            </>
          ) : (
            <Result
              status="403"
              title="403"
              subTitle={t("item.experience.unauthorized")}
            />
          )}
        </HMS.PageListComponent>
      </Fragment>
    );
  }

  onChangeTab = (key) => {
    this.setState({
      listKeyAfterFilter: this.state.listKeyFollowType[key],
    });
  };

  onSelectKey = (value) => {
    this.setState({
      keysDelete: value ? [value] : [],
    });
  };

  onClearCache = () => {
    this.props.deleteCache({ ids: this.state.keysDelete });
  };
}
